import { render, staticRenderFns } from "./IntimatePoliceMedical.vue?vue&type=template&id=ef2e0f24&"
import script from "./IntimatePoliceMedical.vue?vue&type=script&lang=js&"
export * from "./IntimatePoliceMedical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports